import { useEffect, useState, useRef } from "react";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import ArrowDropUp from "@material-ui/icons/ArrowDropUp";
import Button from "react-bootstrap/Button";
import * as theme from "../theme";
import { useDispatch, useSelector } from "react-redux";
import { setTableSortOrder } from "../store/quotes";
const ResultTableHeader = (props) => {
  const {
    ColoumnWidth,
    columnHeadingsQuotes,
    CommonStyleColumn,
    headingStyle,
    direction,
  } = props;
  const dispatch = useDispatch();
  const [directionState, setDirection] = useState(null);
  const [directionState2, setDirection2] = useState(null);
  const [directionState3, setDirection3] = useState(null);

  const prevState = useRef();
  const prevState2 = useRef();
  const prevState3 = useRef();

  useEffect(() => {
    if(prevState.current !== directionState && directionState) {
      direction(directionState, "price");
    }
    if(prevState2.current !== directionState2 && directionState2) {
        direction(directionState2, "score");
    }
    if(prevState3.current !== directionState3 && directionState3) {
      direction(directionState3, "coveragelevel");
  }
    prevState.current = directionState;
    prevState2.current = directionState2;
    prevState3.current = directionState3;
  }, [directionState, directionState2, directionState3]);

  const renderSortIcon = (directionp, col) => {
    let reg = "-";
    if (directionp == "asc") {
      reg = <ArrowDropUp></ArrowDropUp>;
    }
    if (directionp == "desc") { 
      reg = <ArrowDropDown></ArrowDropDown>;
    }

    return (
      <Button
        style={{
          color: "white",
          fontFamily: "GibsonLight",
          fontSize: 12,
          borderColor: "none",
          backgroundColor: "none",
          background: "none",
          border: "none",
          borderRadius: 15,
          Color: "white",
        }}
        onClick={() => {
          moveDirection(directionState, col);
        }}
      >
        {reg}
      </Button>
    );
  };
  const moveDirection = (directionState, col) => {
    // console.log("MoveDirection: ", col)
    var tempStateDirectionF = null;
    var tempStateDirection = null;
    if(col == 'price'){
      setDirection2(null);
      setDirection3(null);
      tempStateDirection = directionState;
      tempStateDirectionF = setDirection;
    }
    else if (col == 'score'){
      setDirection(null);
      setDirection3(null);
      tempStateDirection = directionState2;
      tempStateDirectionF = setDirection2;
    }
    else if (col == 'coveragelevel'){
      setDirection(null);
      setDirection2(null);
      tempStateDirection = directionState3;
      tempStateDirectionF = setDirection3;
    }
    
    if (!tempStateDirection) tempStateDirectionF("asc");
    else if (tempStateDirection == "asc") {
      tempStateDirectionF("desc");
    } else {
      tempStateDirectionF("asc");
    }
  };
  return (
    <div style={headingStyle}>
      <div style={{ width: ColoumnWidth.toggle, ...CommonStyleColumn }}></div>
      <div style={{ width: ColoumnWidth.insurer, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.insurer}
      </div>
      <div style={{ width: ColoumnWidth.product, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.product}
      </div>
      <div
        style={{ width: ColoumnWidth.recommendedscore, ...CommonStyleColumn }}
      >
        {columnHeadingsQuotes.recommendedscore}
        {renderSortIcon(directionState2, "score")}
      </div>
      <div style={{ width: ColoumnWidth.price, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.price}
        {renderSortIcon(directionState, "price")}
      </div>
      <div style={{ width: ColoumnWidth.type, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.type}
      </div>
      <div
        style={{
          width: ColoumnWidth.coveragelevel,
          ...CommonStyleColumn,
        }}
      >
        {columnHeadingsQuotes.coveragelevel}
        {renderSortIcon(directionState3, "coveragelevel")}
      </div>
      <div
        style={{
          width: ColoumnWidth.rateit,
          ...CommonStyleColumn,
          borderRight: 0,
        }}
      >
        {columnHeadingsQuotes.rateit}
      </div>
    </div>
  );
};

export default ResultTableHeader;
